import moment from 'moment-timezone';

export const getYearDaysArray = () => {
  const year = moment().year();
  const days = [];
  const totalDays =
    moment()
      .year(moment().year())
      .endOf('year')
      .diff(moment().year(moment().year()).startOf('year'), 'days') + 1;
  for (let i = 1; i <= totalDays; i++) {
    let date = moment().year(year).dayOfYear(i);
    days.push({
      date: date,
      long: date.format('dddd, MMMM DD'),
      short: date.format('DD/MM/YYYY')
    });
  }
  return days;
};

export const getMonthArray = () => {
  const year = moment().year();
  const months = [];
  for (let i = 1; i <= 12; i++) {
    let month = moment()
      .year(year)
      .month(i - 1);
    months.push({
      month: month,
      formatted: month.format('MMMM, YYYY')
    });
  }
  return months;
};

export const getWeekArray = () => {
  const year = moment().year();
  const weeks = [];
  const totalWeeks =
    moment()
      .year(moment().year())
      .endOf('year')
      .diff(moment().year(moment().year()).startOf('year'), 'weeks') + 1;
  for (let i = 1; i <= totalWeeks; i++) {
    let week = moment().year(year).week(i);

    weeks.push({
      week: i,
      startShort: week.startOf('week').format('MMM, DD'),
      endShort: week.endOf('week').format('MMM, DD'),
      startLong: week.startOf('week').format('MMMM, DD'),
      endLong: week.endOf('week').format('MMMM, DD')
    });
  }
  return weeks;
};

// this format made for api use
export const APIdateFormat = (date) => date.format('YYYY-MM-DD');

// this is for frontend view
export const datetimeformat = (str, timezone) => {
  if (timezone) {
    return moment
      .tz(str, 'YYYY-MM-DDTHH:mm:ssZ', timezone)
      .format('MM-DD-YYYY (HH:mm)');
  } else {
    return moment(str).format('MM-DD-YYYY (HH:mm)');
  }
};
export const dateformat = (str, timezone) => {
  if (timezone) {
    return moment
      .tz(str, 'YYYY-MM-DDTHH:mm:ssZ', timezone)
      .format('MM-DD-YYYY');
  } else {
    return moment(str).format('MM-DD-YY');
  }
};

export const timeFormat = (str,timezone)=>{
  if(timezone) {
    return moment
      .tz(str, 'YYYY-MM-DDTHH:mm:ssZ', timezone)
      .format('hh:mm A');
  } else {
    return moment(str).format('hh:mm A');
  }
}
export const smalldateformat = (str, timezone) => {
  if (timezone) {
    return moment.tz(str, 'YYYY-MM-DDTHH:mm:ssZ', timezone).format('MM-DD-YY');
  } else {
    return moment(str).format('MM-DD-YY');
  }
};

export const timeformat = (str, timezone) => {
  if (timezone) {
    return moment.tz(str, 'YYYY-MM-DDTHH:mm:ssZ', timezone).format('hh:mm A');
  } else {
    return moment(str).format('hh:mm A');
  }
};

export const dateTimeFormFormat = (str, timezone) => {
  if (timezone) {
    return moment
      .tz(str, 'YYYY-MM-DDTHH:mm:ssZ', timezone)
      .format('YYYY-MM-DDTHH:mm');
  } else {
    return moment(str).format('YYYY-MM-DDTHH:mm');
  }
};

export const dateFormFormat = (str, timezone) => {
  if (timezone) {
    return moment
      .tz(str, 'YYYY-MM-DDTHH:mm:ssZ', timezone)
      .format('YYYY-MM-DD');
  } else {
    return moment(str).format('YYYY-MM-DD');
  }
};

export const notesDateFormat = (dateString) => {
  return moment(dateString).format("MM/DD/YYYY, HH:mm")
}

export const BookingDateFormat = (dateString) => { 
  return moment(dateString).format('YYYY-MM-DDTHH:mm');
}

// short US date, e.g. 08/26/26 - used by the deleted leads list
export const shortDateFormat = (dateString) => {
  return moment(dateString).format('MM/DD/YY');
}